// @ vendor
const Immutable = require("immutable");

// @ constants
const actionTypes = require("../constants/actionTypes");

const initialState = Immutable.fromJS({
  iban: "",
  ccc: "",
  verified: false,
  isFetching: false,
  error: "",
  resetNeeded: false,
});

function okIbanReducer(state, action) {
  state = state || initialState;

  switch (action.type) {
    case actionTypes.OKIBAN_SET_IBAN:
      return state.merge(initialState, {
        iban: action.iban,
        ccc: "",
        verified: true,
        isFetching: false,
        error: "",
        resetNeeded: false,
      });

    case actionTypes.OKIBAN_SET_CCC:
      return state.merge(initialState, {
        iban: action.data.iban,
        ccc: action.data.ccc,
        verified: true,
        isFetching: false,
        error: "",
        resetNeeded: false,
      });

    case actionTypes.OKIBAN_VERIFING:
      return state.merge(initialState, {
        verified: false,
        isFetching: true,
        error: "",
        resetNeeded: false,
      });

    case actionTypes.OKIBAN_ERROR:
      return state.merge(initialState, {
        iban: "",
        ccc: "",
        verified: false,
        isFetching: false,
        error: action.data,
        resetNeeded: false,
      });

    case actionTypes.OKIBAN_RESET:
      return state.merge(initialState, {
        iban: "",
        ccc: "",
        isFetching: false,
        verified: false,
        error: "",
        resetNeeded: false,
      });

    case actionTypes.OKIBAN_INTERNAL_RESET:
      return state.merge(initialState, {
        iban: "",
        ccc: "",
        isFetching: true,
        verified: false,
        error: "",
        resetNeeded: true,
      });

    default:
      return state;
  }
}

module.exports = okIbanReducer;
